import { SITE, IMAGES } from "./config";
import { openingHoursSpecification } from "./hours";

export const restaurantSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "@id": `${SITE.domain}/#restaurant`,
  name: SITE.name,
  legalName: SITE.legalName,
  foundingDate: "2024",
  description: "Family-owned Albuquerque birrieria serving Tijuana-style birria de res—quesabirria tacos, tacos dorados, birria ramen and birria pizza.",
  url: SITE.domain,
  image: `${SITE.domain}${IMAGES.og}`,
  logo: `${SITE.domain}${IMAGES.logo}`,
  telephone: SITE.phoneE164,
  email: SITE.email,
  servesCuisine: ["Mexican", "Birria", "Tacos"],
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: SITE.address.street,
    addressLocality: SITE.address.city,
    addressRegion: SITE.address.state,
    postalCode: SITE.address.zip,
    addressCountry: "US",
  },
  geo: { "@type": "GeoCoordinates", latitude: SITE.geo.lat, longitude: SITE.geo.lng },
  openingHoursSpecification,
  hasMenu: `${SITE.domain}/menu`,
  acceptsReservations: "False",
  sameAs: [SITE.facebook, SITE.instagram, SITE.appStoreUrl],
  potentialAction: { "@type": "OrderAction", target: SITE.orderUrl },
});

export const menuSchema = (categories, lang = "en") => ({
  "@context": "https://schema.org",
  "@type": "Menu",
  "@id": `${SITE.domain}/menu#menu`,
  name: `${SITE.name} Menu`,
  inLanguage: lang,
  hasMenuSection: categories.map((cat) => ({
    "@type": "MenuSection",
    name: cat.title.en,
    hasMenuItem: cat.items.map((item) => ({
      "@type": "MenuItem",
      name: item.name,
      description: item.description || undefined,
      offers: { "@type": "Offer", price: item.priceValue, priceCurrency: "USD" },
    })),
  })),
});

export const breadcrumbSchema = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.label,
    item: `${SITE.domain}${c.to}`,
  })),
});
